angular.module('tgaAdmin')
  .controller('QuestionDetailsController', ['$scope', '$uibModalInstance', '$filter', 'extra', 'statsService',
    function ($scope, $uibModalInstance, $filter, extra, statsService) {
      $scope.data = {
        question: extra.question,
        countupOptions: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: ':',
        },
      };

      $scope.viewmodel = {
        answers: [],
        answer_attempts: [],
        avgTime: null,
        questionData: null,
        game: extra.game,
      };

      $scope.initialize = function () {
        const avg_time = $filter('formatDuration')(extra.question.average_time).split(':');
        $scope.viewmodel.avgTime = parseFloat(`${avg_time[1]}.${avg_time[2]}`);

        $scope.viewmodel.answers = extra.question.answers;
        $scope.viewmodel.answer_attempts = extra.question.answer_attempts;

        statsService.getAnswerStats(
          extra.question.question_id,
          extra.startDate.toISOString(true),
          extra.endDate.toISOString(true),
        ).then(
          (results) => {
            $scope.viewmodel.answers = results.stats.answers;
          },
        );
      };

      $scope.actions = {
        ok(data) {
          $uibModalInstance.close(data);
        },
        cancel(data) {
          $uibModalInstance.dismiss(data);
        },
      };

      $scope.initialize();
    },
  ]);
